import axios from "./axios";
import { downloadFile } from "./fileDownloader";

// Get segregate trades data
export const getSegregateTrades = async (filters = {}) => {
  const response = await axios.get("/api/broker-gateway/get-empty-segregated-trades/", {
    params: filters
  });
  return response.data;
};

// Get segregate trades columns
export const getSegregateTradesColumns = async () => {
  const response = await axios.get("/api/analytics/table-schema/segregate_strategy_trade_book_columns/");
  return response.data;
};

// Upload trades file
export const uploadTradesFile = async (payload) => {
  payload = { ...payload, action: "upload" };
  const response = await axios.post("/api/broker-gateway/manual-trade-upload/", payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
};

// Segregate trades action
export const segregateTrades = async (selectedRows) => {
  const payload = {
    action: "segregate",
    trade_ids: selectedRows
  };
  const response = await axios.post("/api/broker-gateway/manual-trade-upload/", payload);
  return response.data;
};

// Get sample file for upload
export const getSegregateTradesSampleFile = () => {
  downloadFile("/api/broker-gateway/manual-trade-upload/sample/");
};

// Get strategy transactions data
export const getStrategyTransactions = async (strategyId) => {
  const response = await axios.get(`/api/broker-gateway/get-segregated-trades/${strategyId}/`);
  return response.data;
};

// Get strategy transactions columns
export const getStrategyTransactionsColumns = async () => {
  const response = await axios.get("/api/analytics/table-schema/segregate_strategy_trade_book_columns/");
  return response.data;
};

// Get batch management data
export const getBatchManagement = async (filters = {}) => {
  const payload = {
    action: "get",
    ...filters
  };
  const response = await axios.post("/api/broker-gateway/batch-management/", payload);
  return response.data;
};

// Upload trades file for batch management
export const uploadBatchTradesFile = async (payload) => {
  payload = { ...payload, action: "upload" };
  const response = await axios.post("/api/broker-gateway/batch-management/", payload, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
};

// Segregate trades action for batch management
export const segregateBatchTrades = async (selectedRows) => {
  const payload = {
    action: "segregate",
    trade_ids: selectedRows
  };
  const response = await axios.post("/api/broker-gateway/batch-management/", payload);
  return response.data;
};

// Get all strategies (for batch creation dropdown)
export const getStrategies = async () => {
  const response = await axios.get("/api/strategy/strategies/");
  return response.data;
};

// Create a new batch for a strategy
export const createStrategyBatch = async (strategyId) => {
  const response = await axios.post("/api/strategy/strategy-batch-data/", {
    strategy_id: strategyId,
  });
  return response.data;
};

// Get segregated strategies (batch management strategy cards)
export const getSegregatedStrategies = async () => {
  const response = await axios.get("/api/broker-gateway/get-segregated-strategies/");
  return response.data;
};

// Get batches for a strategy
export const getStrategyBatches = async (strategyId) => {
  const response = await axios.get(`/api/strategy/get-strategy-batches/${strategyId}/`);
  return response.data;
};

// Get trades inside a batch
export const getSegregatedTradesByBatch = async (batchId) => {
  const response = await axios.get(`/api/broker-gateway/get-segregated-trades-by-batch/${batchId}/`);
  return response.data;
};

// Create a new strategy
export const createStrategy = async (strategyName) => {
  const response = await axios.post("/api/strategy/strategies/", {
    strategy_name: strategyName.trim(),
    strategy_type: "MULTIPLE",
  });
  return response.data;
};

